function importAll(r) {
  let images = {};
  r.keys().map((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const images = importAll(
  require.context("../assets/img", false, /\.(png|jpe?g|svg)$/)
);

export const Products = [
  {
    price: 12,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fd",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Neem powder is made by drying and grinding the leaves of the neem tree (Azadirachta indica), a plant native to India and widely used in Ayurvedic medicine. Neem is known for its powerful antibacterial, antifungal, and anti-inflammatory properties.",
    image: images["neem_powder.jpeg"],
    originalPrice: 12,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Neem Powder",
    type: "Powders",
    unit: "1lb",
    updatedAt: "2022-05-13T03:52:58.986Z",
    sku: "",
    __v: 0,
  },
  {
    price: 13,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fc",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Moringa powder is a natural supplement made by drying and grinding the leaves of the Moringa oleifera tree, often called the drumstick tree or miracle tree. It’s widely recognized for its nutritional benefits and medicinal properties.",
    image: images["moringa_powder.jpeg"],
    originalPrice: 13,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Moringa Powder",
    type: "Powders",
    unit: "5ct",
    updatedAt: "2022-01-19T20:18:00.564Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Curry leaf powder is an aromatic herbal powder used to improve digestion, support hair growth, prevent premature greying, and help regulate blood sugar levels.",
    image: images["curry_leaf_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Curry Leaf Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Tulsi leaf powder is a herbal powder made from dried holy basil leaves, used to support respiratory health, reduce stress, boost immunity, and promote clear skin with its natural antibacterial and adaptogenic properties.",
    image: images["tulsi_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Tulsi (Holy Basil) Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Brahmi powder is a herbal powder made from the Brahmi plant, used to enhance memory, improve focus, reduce anxiety, and support overall brain health due to its calming and neuroprotective properties.",
    image: images["brahmi_leaf_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Brahmi Powder ",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Vanilla powder is a fine, aromatic powder made from dried vanilla beans, used mainly as a natural flavoring in food and beverages. It adds a rich vanilla taste and also offers mild antioxidant properties that can support mood and digestion.",
    image: images["vanila_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Vanilla Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Jaggery powder is a natural sweetener made from concentrated sugarcane juice, used as a healthier alternative to refined sugar. It provides quick energy, aids digestion, cleanses the liver, and is rich in minerals like iron and magnesium.",
    image: images["jaggery_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Jaggery Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Aloe vera powder is made from dehydrated aloe vera gel, used for its soothing, healing, and hydrating properties. It supports skin health, aids digestion, boosts immunity, and helps detoxify the body naturally.",
    image: images["aloevera_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Aloevera Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Dikamali powder is made from the dried gum resin of the Gardenia gummifera plant, traditionally used in Ayurvedic and folk medicine. It is known for its antimicrobial and anti-inflammatory properties, and is commonly used to relieve digestive issues, treat colic in infants, and support oral and joint health.",
    image: images["dikamali_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Dikamali Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Henna powder is a natural dye made from the dried leaves of the henna plant, commonly used for coloring hair and creating temporary body art. It conditions the hair, promotes scalp health, reduces dandruff, and gives a natural reddish-brown tint without chemicals.",
    image: images["heena_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Heena Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Kalmegh powder is a bitter herbal powder made from the Kalmegh plant, used mainly to support liver health, boost immunity, and fight infections. It is also known for its anti-inflammatory and detoxifying properties.",
    image: images["kalmegh_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Kalmegh Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Dashmool powder is an Ayurvedic herbal blend made from the roots of ten medicinal plants, used to balance the body's energies and support overall wellness. It is known for relieving inflammation, strengthening the nervous system, easing joint and muscle pain, and supporting postpartum recovery.",
    image: images["dashmool_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Dashmool Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Mint powder is a fragrant herbal powder made from dried mint leaves, used for its cooling and refreshing effects. It aids digestion, relieves nausea, freshens breath, and helps soothe skin irritation and headaches.",
    image: images["mint_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Mint (Pudina) Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["herbal powders", 'powders'],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "herbal_natural_leaf_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Banana leaves powder is made from dried banana leaves and is used for its antioxidant, antibacterial, and anti-inflammatory properties. It supports digestive health, promotes skin healing, and may help detoxify the body naturally.",
    image: images["banana_leaf_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 1000,
    slug: "powder",
    title: "Bannana Leaves Powder",
    type: "Powders",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Ashwagandha powder is a traditional herbal supplement made from the root of the ashwagandha plant, known for its adaptogenic properties. It helps reduce stress, boost energy and stamina, improve sleep quality, and support hormonal and immune balance.",
    image: images["ashwagandha_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Ashwagandha Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Nannari root powder is made from the roots of the Indian sarsaparilla plant, commonly used for its cooling and detoxifying effects. It helps purify the blood, supports digestion, prevents urinary infections, and naturally cools the body during heat or summer.",
    image: images["nannari_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Nannari Root Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Shatavari powder is made from the root of the shatavari plant and is widely used in Ayurveda to support female reproductive health. It helps balance hormones, boosts fertility, enhances lactation, and also supports digestion and immunity.",
    image: images["shatavari powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Shatavari Root Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Licorice powder is made from the root of the licorice plant and is used for its soothing and anti-inflammatory properties. It supports respiratory health, relieves acidity and digestive discomfort, promotes clear skin, and helps balance hormones naturally.",
    image: images["licorice_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Licorice (Mulethi) Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Arrowroot powder is a fine, white starch extracted from the roots of the arrowroot plant, commonly used as a natural thickening agent in cooking. It is easy to digest, helps soothe the digestive tract, supports healthy bowel movements, and is gentle enough for use in baby foods and skin care.",
    image: images["arrowroot_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Arrowroot Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Turmeric root powder is a bright yellow spice made from dried turmeric roots, widely used for its powerful anti-inflammatory and antioxidant properties. It supports joint health, boosts immunity, aids digestion, promotes glowing skin, and helps manage inflammation-related conditions.",
    image: images["termeric_root_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Turmeric Root Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Vetiver (Khus) root powder is made from dried vetiver roots and is known for its cooling, calming, and detoxifying properties. It helps purify the blood, supports skin health, reduces body heat, and promotes relaxation and better sleep.",
    image: images["vetiver_root_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Vetiver Root Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Safed Musli powder is made from the roots of the Safed Musli plant and is valued for its rejuvenating and aphrodisiac properties. It helps improve stamina, boost strength and vitality, enhance sexual health, and support overall immunity and hormonal balance.",
    image: images["safed_musli_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Safed Musli Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Carrot powder is made from dried and ground carrots, used as a natural source of vitamins and antioxidants. It supports eye health, boosts immunity, improves skin texture, and aids digestion while adding mild sweetness and color to foods.",
    image: images["carrot_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Carrot Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Potato powder is made from dehydrated potatoes and is commonly used as a thickener or base in cooking. It provides quick energy, supports skin health, helps soothe inflammation, and can be used in face packs to reduce puffiness and brighten the complexion.",
    image: images["potato_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Potato Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["root powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "root_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sweet potato powder is made from dried sweet potatoes and is rich in fiber, vitamins, and antioxidants. It supports digestive health, provides sustained energy, helps regulate blood sugar levels, and promotes healthy skin and immunity.",
    image: images["sweet_potato_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Sweet Potato Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rhizome/tuber powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "rhizome_tuber_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Ginger powder is made from dried ground ginger root and is known for its strong, spicy flavor and medicinal properties. It aids digestion, reduces nausea, relieves inflammation, boosts immunity, and helps soothe cold and flu symptoms.",
    image: images["ginger_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Ginger Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rhizome/tuber powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "rhizome_tuber_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Dry turmeric powder is made from sun-dried turmeric roots and is widely used for its medicinal and culinary benefits. It helps reduce inflammation, boosts immunity, supports joint and skin health, and aids in digestion and liver function.",
    image: images["dry_termeric_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Dry Turmeric Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rhizome/tuber powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "rhizome_tuber_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Galangal powder is made from dried galangal root and is known for its sharp, citrusy flavor and medicinal properties. It aids digestion, reduces inflammation, supports respiratory health, and helps fight infections with its antimicrobial and antioxidant effects.",
    image: images["galangal_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Galangal Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rhizome/tuber powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "rhizome_tuber_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Amba Haldi (Wild Turmeric) powder is made from the rhizome of a special turmeric variety known for its strong aroma and medicinal properties. It is commonly used to enhance skin health, reduce acne and blemishes, promote wound healing, and provide natural antibacterial and anti-inflammatory benefits.",
    image: images["amba_haldi.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Wild Turmeric Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rhizome/tuber powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "rhizome_tuber_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Kasturi Manjal powder, also known as wild turmeric, is a fragrant variety of turmeric mainly used for cosmetic and skincare purposes. It helps brighten the skin, reduce acne, remove facial hair, and improve complexion without staining the skin like regular turmeric.",
    image: images["kasturi_manjal_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Kasturi Manjal Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Fenugreek (Methi) powder is made from ground fenugreek seeds and is known for its nutritional and medicinal value. It helps regulate blood sugar, boosts digestion, enhances hair growth, reduces dandruff, and supports hormonal balance, especially in women.",
    image: images["fenugreek_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Fenugreek (Methi) Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Flaxseed powder is made from ground flaxseeds and is rich in omega-3 fatty acids, fiber, and lignans. It supports heart health, aids digestion, helps regulate hormones, promotes healthy skin, and may assist in weight management.",
    image: images["flaxseed_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Flaxseed Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Arjun bark powder is made from the bark of the Arjuna tree and is traditionally used to support heart health. It strengthens the heart muscles, helps regulate blood pressure and cholesterol levels, and provides antioxidant and anti-inflammatory benefits.",
    image: images["arjun_bark_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Arjun Bark Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Harad bark powder is made from the bark or fruit of the Harad (Haritaki) tree and is known for its powerful cleansing and rejuvenating properties. It aids digestion, supports detoxification, improves bowel movements, boosts immunity, and promotes overall vitality.",
    image: images["harad_bark_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Harad Bark Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Neem bark powder is made from the dried bark of the neem tree and is valued for its strong antimicrobial and anti-inflammatory properties. It helps purify the blood, supports oral and digestive health, promotes clear skin, and aids in managing infections and inflammation.",
    image: images["neem_bark_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Neem Bark Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Quillaja powder is made from the bark of the Quillaja saponaria tree, also known as soapbark. It is rich in natural saponins and is used as a foaming agent in beverages and cosmetics. It also supports respiratory health, acts as an expectorant, and may help boost immunity and skin cleansing.",
    image: images["quillaja_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Quallja powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Corn powder is made from finely ground dried corn and is commonly used in cooking and baking. It provides quick energy, supports digestion with its fiber content, and contains essential nutrients like B vitamins and antioxidants that contribute to overall health.",
    image: images["corn_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Corn Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["seed/bark powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "seed_bark_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Lemon powder is made from dried lemon peel or juice and is used for its tangy flavor and health benefits. It aids digestion, boosts immunity with its high vitamin C content, supports skin health, and helps in detoxifying the body naturally.",
    image: images["lemon_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Lemon Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Amla (Indian Gooseberry) powder is made from dried amla fruit and is known for its high vitamin C and antioxidant content. It boosts immunity, promotes healthy hair and skin, supports digestion, and helps detoxify the body while enhancing overall vitality.",
    image: images["amla_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Amla Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Hibiscus powder is made from dried hibiscus flowers and is known for its rich antioxidant and vitamin content. It promotes hair growth, strengthens roots, adds shine, supports heart health, aids digestion, and helps maintain healthy skin and a clear complexion.",
    image: images["hibiscus_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Hibiscus Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Rose petal powder is made from dried rose petals and is prized for its soothing, cooling, and aromatic properties. It helps rejuvenate the skin, reduce acne and inflammation, tone the skin naturally, and is also used to promote relaxation and emotional well-being.",
    image: images["rose_petal_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Rose Petal Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Reetha (Soapnut) powder is made from dried soapnut fruit and is a natural cleanser known for its gentle foaming properties. It is commonly used for washing hair and skin, promoting scalp health, reducing dandruff, and acting as a chemical-free alternative to shampoos and soaps.",
    image: images["reetha_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Reetha (Soapnut) Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Shikakai powder is made from the dried pods of the Shikakai plant and is traditionally used as a natural hair cleanser. It gently cleans the scalp, promotes hair growth, reduces dandruff, prevents hair fall, and adds softness and shine without stripping natural oils.",
    image: images["shikakai_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Shikakai Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Baheda powder is made from the dried fruit of the Baheda (Bibhitaki) tree and is known for its rejuvenating and detoxifying properties. It supports respiratory health, improves digestion, promotes hair growth, and is one of the key ingredients in the Ayurvedic formula Triphala.",
    image: images["baheda_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Baheda Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["flower/fruit powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "flower_fruit_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Haritaki powder is made from the dried fruit of the Haritaki tree and is revered in Ayurveda for its cleansing and rejuvenating effects. It supports digestion, relieves constipation, boosts immunity, enhances memory, and promotes overall detoxification and vitality.",
    image: images["haritaki_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Haritaki Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Mango powder, also known as amchur, is made from dried unripe green mangoes and is commonly used as a tangy spice in cooking. It aids digestion, boosts appetite, provides vitamin C, and adds a natural sour flavor to dishes without moisture.",
    image: images["amchur_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Mango Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tomato powder is made from dried, ground tomatoes and is used as a natural flavor enhancer in cooking. It is rich in antioxidants like lycopene, supports heart and skin health, boosts immunity, and adds a tangy taste to soups, sauces, and snacks.",
    image: images["tomato_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Tomato Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Ginger powder is made from dried and ground ginger root and is widely used for its spicy flavor and medicinal properties. It aids digestion, reduces nausea, relieves inflammation, supports respiratory health, and helps boost immunity.",
    image: images["ginger_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Ginger Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Garlic powder is made from dried and ground garlic cloves and is used for its strong flavor and medicinal properties. It supports heart health, helps lower cholesterol and blood pressure, boosts immunity, fights infections, and aids digestion.",
    image: images["garlic_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Garlic Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Onion powder is made from dehydrated and finely ground onions and is used as a convenient seasoning in cooking. It adds rich flavor, supports digestion, boosts immunity, has antioxidant properties, and may help regulate blood sugar levels.",
    image: images["onion_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Onion Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Curry leaf powder is made from dried curry leaves and is used for its aromatic flavor and health benefits. It aids digestion, supports hair growth, helps control blood sugar levels, and is rich in antioxidants that promote overall wellness.",
    image: images["curry_leaf_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Curry Leaf Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Coriander powder is made from ground dried coriander seeds and is widely used as a spice in cooking. It aids digestion, helps regulate blood sugar, supports heart health, and provides antioxidants that contribute to overall well-being.",
    image: images["coriander_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Coriander Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Cumin powder is made from ground dried cumin seeds and is known for its warm, earthy flavor and medicinal properties. It aids digestion, boosts metabolism, supports immunity, and helps improve iron levels in the body.",
    image: images["cumin_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Cumin Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Fennel powder is made from dried and ground fennel seeds and is commonly used for its sweet aroma and soothing properties. It aids digestion, relieves bloating and gas, freshens breath, supports hormonal balance, and promotes respiratory and overall wellness.",
    image: images["fennel_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Fennel Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Mustard powder is made from ground mustard seeds and is used for its pungent flavor and therapeutic properties. It stimulates digestion, boosts metabolism, relieves muscle pain, supports respiratory health, and has natural antibacterial effects.",
    image: images["mustard_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Mustard Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Chili powder is made from dried and ground chili peppers and is used to add heat and flavor to dishes. It boosts metabolism, aids digestion, supports pain relief, and provides antioxidants like capsaicin that promote heart and immune health.",
    image: images["chili_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Chili Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tamarind powder is made from dried tamarind pulp and is used to add a tangy, sour flavor to various dishes. It aids digestion, helps regulate bile production, supports heart health, and provides antioxidants and vitamin C for overall wellness.",
    image: images["tamarind_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Tamarind Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sambar powder is a flavorful spice blend made from roasted lentils, spices, and herbs, used primarily in South Indian cuisine. It enhances taste, aids digestion, supports metabolism, and provides antioxidant benefits through its rich mix of ingredients like coriander, cumin, fenugreek, and dried chilies.",
    image: images["sambar_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Sambar Powder",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Pav Bhaji masala is a flavorful spice blend made from a mix of aromatic spices like coriander, cumin, fennel, chili, and dry mango, used to season the popular Indian street food Pav Bhaji. It enhances flavor, stimulates appetite, aids digestion, and adds a spicy, tangy depth to various vegetable dishes.",
    image: images["pavbhaji_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Pav Bhaji Masala",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Chat masala is a tangy and spicy spice blend made from ingredients like dried mango powder, black salt, cumin, and asafoetida. It enhances the flavor of snacks and salads, aids digestion, stimulates appetite, and adds a zesty twist to fruits, chaats, and drinks.",
    image: images["chat_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Chat Masala",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["food powders", "powders"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "food_powder",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Garam masala is a warm, aromatic spice blend made from ground spices like cinnamon, cardamom, cloves, cumin, and black pepper. It enhances the flavor of Indian dishes, supports digestion, boosts metabolism, and provides antioxidant and anti-inflammatory benefits.",
    image: images["garam_masala_powder.jpeg"],
    originalPrice: 15,
    parent: "Powders",
    quantity: 42,
    slug: "powder",
    title: "Garam Masala",
    type: "Powders",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Baked banana chips are thin slices of ripe or raw bananas that are baked until crisp, offering a healthier alternative to fried snacks. They are naturally sweet or lightly salted, rich in fiber and potassium, and make for a light, guilt-free snack.",
    image: images["banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Baked Banana Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Jackfruit chips are made from thinly sliced raw jackfruit that is typically deep-fried or sometimes baked until crisp. They have a slightly sweet, nutty flavor and are rich in fiber, making them a crunchy and satisfying snack with natural nutrients.",
    image: images["jackfruit_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Jackfruit Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tapioca (Cassava) chips chilly are thin slices of cassava root seasoned with spicy chili flavor and fried or baked to a crisp. They are crunchy, gluten-free snacks that provide quick energy and a bold, spicy taste loved in many traditional cuisines.",
    image: images["tapioca_chips_chili.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Cassava Chips Chilly",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Banana jaggery chips are made by coating banana slices with melted jaggery and then drying or lightly frying them for a sweet, crunchy treat. They offer a natural source of energy, combine the goodness of bananas and jaggery, and are rich in iron, fiber, and antioxidants.",
    image: images["banana_jaggery_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Banana Jaggery Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Banana chips crisps thick are thicker-cut slices of raw banana that are usually deep-fried until golden and crunchy. They have a hearty texture, mild saltiness, and are a popular, satisfying snack rich in potassium and dietary fiber.",
    image: images["banana_chips_thick.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Banana Chips Thick",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Bittergourd chips are made from thinly sliced bitter gourd (karela) that is spiced and fried or baked until crisp. Despite their slightly bitter taste, they are rich in antioxidants, help regulate blood sugar levels, and make a crunchy, health-focused snack.",
    image: images["bitterground_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Bittergourd Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Plantain raw banana chips are made from unripe plantains sliced thin and fried until crispy, often seasoned with salt or spices. They are a savory snack rich in fiber and potassium, known for their firm texture and mildly starchy taste.",
    image: images["raw_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Plantain Banana Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Potato chips pudhina are crispy potato slices flavored with mint (pudhina) seasoning for a refreshing, herby twist. They offer the classic crunch of chips with a cool, tangy flavor and are a popular snack enjoyed for their taste and aroma.",
    image: images["pudhina_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Potato Chips Pudhina",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tapioca chips salsa are crisp slices of cassava root coated with tangy and mildly spicy salsa seasoning. They combine the crunchy texture of traditional tapioca chips with a zesty, savory flavor, making them a bold and flavorful snack choice.",
    image: images["salsa_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Tapioca Chips Salsa",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Garlic potato chips are thinly sliced potatoes fried or baked until crispy and seasoned with savory garlic flavor. They offer a rich, aromatic taste, combining classic crunch with the bold, appetizing essence of garlic for a flavorful snacking experience.",
    image: images["garlic_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Garlic Potato Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Chilly mango potato chips are crispy potato slices coated with a unique blend of spicy chili and tangy mango flavors. They deliver a bold, sweet-and-spicy taste, making them an exciting and flavorful twist on traditional chips.",
    image: images["chilli_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Mango Potato Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tandoori potato chips are thin potato slices seasoned with a smoky, spicy tandoori masala blend and cooked until crisp. They offer a rich, bold flavor inspired by traditional Indian tandoori dishes, making them a savory and aromatic snack.",
    image: images["tandoori_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Tandoori Potato Chips",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Lime & onion potato chips are crispy potato slices flavored with a tangy lime and savory onion seasoning. They offer a zesty, slightly sweet-and-sour taste with a hint of spice, making them a refreshing and flavorful snack option.",
    image: images["lime_onion_banana_chips.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Lime&Onion Potato",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tapioca chips stick are thin, elongated strips made from cassava root that are fried until golden and crispy. They offer a crunchy texture with a mildly earthy taste and are a gluten-free snack often seasoned with salt or spices for added flavor.",
    image: images["tapioca_chips_stick.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Tapioca Chips Stick",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sesame ribbon pakoda is a crispy South Indian snack made from rice flour and gram flour, shaped into flat ribbons and deep-fried with sesame seeds. It has a crunchy texture and a mildly spiced, nutty flavor, making it a popular festive or tea-time treat.",
    image: images["sesame_ribbon_pakoda.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Sesame Ribbon Pakoda",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Banana 4 cut salt refers to raw bananas sliced into four long pieces (lengthwise) and lightly salted before frying or baking. This savory snack is crisp on the outside, soft inside, and rich in fiber and potassium, offering a simple and satisfying flavor.",
    image: images["banana_cut.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Banana 4 Cut",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Cheese balls puff are airy, round snacks made from puffed corn and coated with a rich cheese seasoning. They are light, crispy, and melt in the mouth, offering a savory, cheesy flavor that's perfect for quick snacking.",
    image: images["cheese_balls.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Cheese Balls",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Kara boondhi is a spicy South Indian snack made from gram flour batter dropped into hot oil as tiny round droplets and then seasoned with salt and spices. It is crunchy, flavorful, and often enjoyed as a standalone snack or mixed into South Indian mixtures.",
    image: images["kara_boondhi.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Kara Boondhi",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Choco popcorn is a sweet snack made by coating freshly popped corn with a layer of chocolate, creating a crunchy and indulgent treat. It combines the lightness of popcorn with the rich flavor of chocolate, making it a favorite for dessert or movie-time snacking.",
    image: images["choco_popcorn.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Choco Popcorn",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chips", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chips",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Coffee popcorn is a unique snack made by coating popped corn with a coffee-flavored glaze or seasoning. It combines the light crunch of popcorn with the bold, aromatic taste of coffee, offering a sweet and slightly bitter treat for coffee lovers.",
    image: images["coffee_popcorn.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Coffee Popcorn",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["murukku", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "murukku",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Hand murukku is a traditional South Indian snack made from rice flour and spices, hand-shaped into spiral patterns and deep-fried until crisp. It is crunchy, mildly spiced, and often enjoyed during festivals or as an everyday savory treat.",
    image: images["hand_murukku.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Hand Murukku",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["murukku", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "murukku",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Thattai murukku is a crispy South Indian snack made from rice flour, urad dal flour, and spices, flattened into discs and deep-fried. It has a crunchy texture with a mildly spiced, savory flavor and is commonly enjoyed during festive occasions or as a tea-time snack.",
    image: images["thattai_murukku.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Thattai Murukku",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["murukku", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "murukku",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Chilly murukku is a spicy variation of the traditional South Indian murukku, made from rice flour and infused with red chili powder for extra heat. It offers a crunchy texture and bold, fiery flavor, making it a popular choice for spice lovers.",
    image: images["chilly_murukku.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Chilly Murukku",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["murukku", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "murukku",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Butter murukku is a soft and crispy South Indian snack made from rice flour, gram flour, and butter, which gives it a rich, melt-in-the-mouth texture. It has a mildly salty, buttery flavor and is a popular festive and everyday savory treat.",
    image: images["butter_murukku.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Butter Murukku",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["murukku", "munchies"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "murukku",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Garlic murukku salt is a savory South Indian snack made from rice flour blended with garlic paste and mild salt seasoning, then deep-fried into crunchy spirals. It offers a flavorful twist with the aroma of garlic and a light, satisfying crunch.",
    image: images["garlic_murukku.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Garlic Murukku Salt",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["halwa", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "halwa",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Kerala black jaggery halwa is a traditional sweet made with rice flour, coconut milk, and dark palm jaggery, slow-cooked to a rich, glossy texture. It has a deep, caramel-like flavor with a hint of nuttiness and is known for its chewy, melt-in-the-mouth consistency.",
    image: images["jaggery_halwa.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Kerala Jaggery Halwa",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["halwa", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "halwa",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Kerala pineapple halwa is a fruity, rich dessert made with pineapple pulp, sugar, ghee, and flour, slow-cooked until glossy and firm. It offers a sweet and slightly tangy flavor with a tropical aroma, often enjoyed as a festive treat or special occasion sweet.",
    image: images["pineapple_halwa.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Kerala Pineapple Halwa",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["halwa", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "halwa",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Traditional wheat halwa is a rich and glossy Indian sweet made by slow-cooking wheat flour, ghee, and sugar until it reaches a soft, chewy texture. It has a deep, caramelized flavor and is often flavored with cardamom and garnished with nuts for added richness.",
    image: images["wheat_halwa.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Traditional Wheat Halwa",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["halwa", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "halwa",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Wheat jaggery coconut milk halwa is a traditional sweet made by blending wheat flour with coconut milk and jaggery, then slow-cooked with ghee until smooth and glossy. It offers a naturally sweet, nutty flavor with a rich, melt-in-the-mouth texture and wholesome ingredients.",
    image: images["coconut_milk_halwa.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Coconut Milk Halwa",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chikki", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chikki",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Broken peanut chikki bar candy is a traditional Indian sweet made from roasted broken peanuts and jaggery, pressed into bars. It has a crunchy texture and a rich, nutty flavor, providing a natural source of energy, protein, and minerals like iron.",
    image: images["peanut_chikki_bar.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Peanut Chikki Bar",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chikki", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chikki",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Peanut chikki button is a bite-sized version of the classic peanut chikki, made from whole roasted peanuts and jaggery molded into small, round discs. It offers a crunchy, sweet-nutty flavor and is a convenient, energy-rich snack perfect for quick bites.",
    image: images["peanut_chikki_button.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Peanut Chikki Button",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chikki", "sweet"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "chikki",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Black sesame button candy is a small, round treat made from roasted black sesame seeds and jaggery, pressed into compact discs. It has a rich, nutty-sweet flavor and is packed with calcium, iron, and healthy fats, making it both tasty and nutritious.",
    image: images["sesame_button.jpeg"],
    originalPrice: 15,
    parent: "chips_and_more",
    quantity: 42,
    slug: "chips and more",
    title: "Sesame Button Candy",
    type: "chips_and_more",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Tofu fries are crispy strips made from firm tofu that are seasoned and baked or fried until golden. They are a protein-rich, plant-based snack or side dish with a soft inside and a crunchy outer layer, perfect for dipping or enjoying on their own.",
    image: images["tofu_fries.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Tofu Fries",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "French fries are thin, elongated pieces of potato that are deep-fried or baked until golden and crispy. They are a classic, savory snack or side dish enjoyed for their crunchy texture and soft interior, often served with ketchup or seasoning.",
    image: images["french_fries.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "French Fries",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Smiles Fries are frozen potato snacks shaped into playful smiley faces and pre-seasoned for convenience. They’re easy to bake or air-fry, offering a kid-friendly, crispy-on-the-outside and fluffy-inside treat perfect for dipping.",
    image: images["smiles_fries.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Mccain Smiles Fries",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Masala Fries are frozen potato fries coated in a spicy blend of six Indian spices (including garlic, chili, onion, pepper, and fenugreek), designed to be baked, air-fried, or deep-fried straight from the freezer. They offer a crispy, flavorful snack with a hot and tangy twist.",
    image: images["masala_fries.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Mccain Masala Fries",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain French Crinkle (Pepper Crunch) are pre-seasoned, crinkle-cut frozen fries coated with bold peppery spices. They’re ready to cook straight from the freezer—just bake, air-fry, or fry—and deliver a crispy texture and zesty flavor in about 3 minutes . Whether you're hosting a party or craving a spicy snack, they're a quick and flavorful choice.",
    image: images["fries_crinkle.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "McCain French Crinkle",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Chilli Garlic Potato Pops are crispy, bite-sized frozen potato nuggets infused with bold chilli and garlic seasoning, designed to be cooked straight from the freezer by baking, air-frying, or deep-frying in just 3 minutes . They offer a savory, spicy kick ideal as a quick snack, dipping appetizer, or party treat.",
    image: images["potato_pops.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "McCain Potato Pops",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Potato Rostiko Rounds (McCain Rostiko Rounds) are crispy, round hash-brown-style potato snacks made from shredded potatoes seasoned with a hint of curry, pre-fried, then frozen for convenience. They feature a tender interior and crunchy exterior, suitable as a grab-and-go snack, versatile side, or burger topper with quick easy cooking straight from the freezer .",
    image: images["potato_rostiko_rounds.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Potato Rostiko Round",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "fries", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "fries_snacks",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Savoury Wedges are frozen, skin-on potato wedges coated with a crispy herb-and-batter seasoning that includes parsley and mild spices.",
    image: images["savoury_wedges.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Mccain Savoury Wedges",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "tikkis", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "patties_tikkis",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Aloo Tikki is a frozen potato patty blended with traditional Indian spices, ready to bake, air-fry, or deep-fry straight from the freezer.",
    image: images["aloo_tikki.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "McCain Aloo Tikki",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "tikkis", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "patties_tikkis",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Plant-Based Grill Juicy Tikki is a vegan, freeze-ready burger patty made from wheat and soy protein, seasoned with traditional spices. It grills up juicy and flavorful in just a few minutes, offering a plant-based, JAIN-friendly option for burgers without compromising taste .",
    image: images["plant_based_tikki.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Plant-Based Tikki",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "patties", "patty", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "patties_tikkis",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Herb Chilli Potato Patty is a frozen, round potato patty made from shredded potatoes mixed with chili flakes and herbs, pre-cooked and ready straight from the freezer. ",
    image: images["potato_patty.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "McCain Potato Patty",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "patties", "patty", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "patties_tikkis",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Soya Burger Patty is a plant-based burger patty made from textured soy protein, wheat gluten, and spices.",
    image: images["burger_patty.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Soya Burger Patty",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "patties", "patty", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "patties_tikkis",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Veg Burger Patty is a pre-cooked, frozen plant-based patty made primarily from vegetables like potato, carrot, peas, and corn, coated in crispy breadcrumbs.",
    image: images["veg_burger_patty.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Veg Burger Patty",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "nuggets", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "crispy_bites",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Soya nuggets are frozen or dehydrated plant-based bites made from textured soy protein, often coated in breadcrumbs, offering a crispy exterior and chewy, meat-like interior when cooked",
    image: images["soya_nuggets.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Soya Nuggets",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "nuggets", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "crispy_bites",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "McCain Tandoori Veggie Nuggets are frozen plant‑based nuggets made from potatoes and vegetables coated in a crispy, bold tandoori-spiced breadcrumb.",
    image: images["tandoori_nuggets.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "McCain Tandoori Nuggets",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "nuggets", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "crispy_bites",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Veg crispy lollipops—or veggie lollipops—are bite‑sized, skewered balls made from a seasoned mixture of mashed potatoes and finely chopped vegetables, coated in a light batter and breadcrumbs. ",
    image: images["veg_lollipop.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Veg Crispy Lollipop",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "nuggets", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "crispy_bites",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Crispy Veg Chikn (Frozen) is a plant based snack made from soy and wheat proteins, seasoned with garlic, ginger, mustard oil, and spices, then coated in a crispy outer layer.",
    image: images["veg_chicken.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Crispy Veg Chikn",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Soya Shawarma is a plant-based, ready-to-cook strip made primarily from soy and wheat proteins, seasoned with shawarma-style spices like garlic, cumin, onion, and paprika.",
    image: images["soya_shwarma.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Soya Shawarma",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Black Pepper Sausage typically refers to pre-seasoned, frozen vegetarian or meat-based sausages flavored with cracked black pepper for a zesty kick.",
    image: images["sausage.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Sausage Black Pepper",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Masala Soft Tofu is ready-to-cook soft tofu infused with traditional Indian masala spices, sold frozen for convenience. Its spongy texture (enhanced by freezing) absorbs flavors deeply, making it ideal for curries, wraps, stir-fries, or grilling after thawing and cooking—no extra seasoning needed.",
    image: images["masala_tofu.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Masala Soft Tofu",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Soya Chop Stick (plant-based) are ready-to-cook soy and wheat protein sticks seasoned with spices and pre-fried for convenience.",
    image: images["chops_stick.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Chops Stick",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Soya Chaap is a ready-to-cook, plant-based protein option made from soy and wheat flour or textured soy protein, designed to mimic the texture of meat. It absorbs flavors exceptionally well, making it versatile for Indian-style curries, tandoori dishes, stir-fries, and kebabs .",
    image: images["soya_chaap.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Soya Chaap",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["frozen", "plant based", "snacks"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "plant_based",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Frozen Veg Meat Tikka is a ready-to-cook, plant-based tikka made primarily from soy and wheat proteins, seasoned to mimic traditional meat tikka flavors.",
    image: images["veg_meat_tikka.jpeg"],
    originalPrice: 15,
    parent: "frozen_food",
    quantity: 42,
    slug: "frozen food",
    title: "Veg Meat Tikka",
    type: "frozen_food",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Hydroxide is a strong alkaline compound also known as caustic soda. It is commonly used in soap making, cleaning agents, drain cleaners, and in industries for pH regulation and chemical manufacturing due to its ability to break down organic matter and neutralize acids.",
    image: images["sodium_hydroxide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Hydroxide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Linear Alkyl Benzene (LAB) is an organic compound used primarily as a raw material in the production of linear alkylbenzene sulfonate (LAS), a key ingredient in biodegradable detergents and cleaning products.",
    image: images["linear_alkyl_benzene.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Linear Alkyl Benzene",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Lauryl Sulfate (SLS) is a surfactant and foaming agent. It enhances the cleaning effectiveness of formulations.",
    image: images["sodium_lauryl_sulfate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Lauryl Sulfate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Tripolyphosphate (STPP) is a cleaning and water-softening agent commonly used in detergents, dishwashing products, and some food processing. It helps prevent mineral deposits on surfaces, enhances cleaning power, and acts as a preservative in seafood and meat products.",
    image: images["sodium_tripolyphosphate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Tripolyphosphate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Carbonate, also known as washing soda or soda ash, is a cleaning and water-softening agent widely used in laundry detergents, glass manufacturing, and pH control. It helps remove stains, cut grease, and balance acidity in various industrial and household applications.",
    image: images["sodium_carbonate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Carbonate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Silicate, also known as water glass, is a compound used in detergents, adhesives, and water treatment. It acts as a binder, corrosion inhibitor, and cleaning booster, making it valuable in industrial cleaning products and cement formulations.",
    image: images["sodium_silicate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Silicate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Chloride, commonly known as table salt, is used in preservation as well as in industrial processes like water softening and chemical production. It also serves as a stabilizer and thickener in personal care products and cosmetics.",
    image: images["sodium_chloride.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Chloride",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Optical Brighteners are chemical compounds added to detergents, textiles, and paper to enhance whiteness and brightness. They work by absorbing UV light and re-emitting it as visible blue light, making materials appear cleaner and more vibrant.",
    image: images["optical_brighteners.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Optical Brighner",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Enzymes like Protease, Amylase, and Lipase are biological agents used in detergents to break down stains.",
    image: images["enzymes.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Enzymes",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Polycarboxylates are synthetic polymers used in detergents as water softeners and anti-redeposition agents.",
    image: images["polycarboxylates.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Polycarboxylates",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Cocamidopropyl Betaine is a mild surfactant derived from coconut oil, commonly used in shampoos, body washes, and liquid soaps. It helps create foam, cleanse the skin or hair gently, and reduce irritation when combined with stronger surfactants.",
    image: images["cocamidopropyl_betaine.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Cocamidopropyl Betaine",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Cocamide DEA/MEA are thickening and foaming agents derived from coconut oil, used in shampoos, body washes, and other personal care products. They enhance foam stability and viscosity, making the product feel richer and improving its cleansing performance.",
    image: images["cocamide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Cocamide DEA/MEA",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Citric Acid is a natural, weak organic acid used in food, cosmetics, and cleaning products. It acts as a pH adjuster, preservative, and chelating agent, helping to remove limescale, soften water, and extend product shelf life.",
    image: images["citric_acid.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Citric Acid",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Glutamic Acid is an amino acid used in food as a flavor enhancer and in cosmetics for its moisturizing and conditioning properties. It helps maintain skin hydration and is also a building block in the production of glutamates like MSG (monosodium glutamate).",
    image: images["glutamic_acid.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Glutamic Acid",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Polyethylene Glycol (PEG) is a synthetic compound used in cosmetics, pharmaceuticals, and industrial products. It functions as a humectant, thickener, or solvent, helping to retain moisture, improve texture, and enhance the stability of formulations.",
    image: images["polyethylene_glycol.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Polyethylene Glycol",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Alkyl Polyglucosides (APGs) are mild, plant-derived surfactants commonly used in natural and eco-friendly cleaning and personal care products. They provide gentle cleansing and good foaming without irritating the skin, making them suitable for baby products and sensitive skin formulations.",
    image: images["alkylpolyglucosides.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Alkyl Polyglucosides",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Lauryl Ether Sulfate (SLES) is a widely used surfactant and foaming agent in shampoos, body washes, and household cleaners. It effectively removes oils and dirt while producing rich lather, offering a gentler alternative to Sodium Lauryl Sulfate (SLS).",
    image: images["SLES.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "SLES",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Sodium Dodecylbenzenesulfonate is a powerful anionic surfactant used in household and industrial detergents. It effectively breaks down grease and oily stains, making it a key ingredient in laundry powders, dishwashing liquids, and cleaning agents.",
    image: images["SDBS.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "SDBS",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "detergents"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "detergents_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Polyacrylamide is a water-soluble polymer used in water treatment, cosmetics, and agriculture. It acts as a thickener, flocculant, and stabilizer, helping to bind particles, improve texture, and enhance water retention in various formulations.",
    image: images["polyacrylamide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Polyacrylamide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Hydroxide is a strong alkaline compound also known as caustic soda. It is commonly used in soap making, cleaning agents, drain cleaners, and in industries for pH regulation and chemical manufacturing due to its ability to break down organic matter and neutralize acids.",
    image: images["sodium_hydroxide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Hydroxide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Linear Alkyl Benzene (LAB) is an organic compound used primarily as a raw material in the production of linear alkylbenzene sulfonate (LAS), a key ingredient in biodegradable detergents and cleaning products.",
    image: images["linear_alkyl_benzene.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Linear Alkyl Benzene",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Lauryl Sulfate (SLS) is a surfactant and foaming agent. It enhances the cleaning effectiveness of formulations.",
    image: images["sodium_lauryl_sulfate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Lauryl Sulfate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Tripolyphosphate (STPP) is a cleaning and water-softening agent commonly used in detergents, dishwashing products, and some food processing. It helps prevent mineral deposits on surfaces, enhances cleaning power, and acts as a preservative in seafood and meat products.",
    image: images["sodium_tripolyphosphate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Tripolyphosphate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Carbonate, also known as washing soda or soda ash, is a cleaning and water-softening agent widely used in laundry detergents, glass manufacturing, and pH control. It helps remove stains, cut grease, and balance acidity in various industrial and household applications.",
    image: images["sodium_carbonate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Carbonate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Silicate, also known as water glass, is a compound used in detergents, adhesives, and water treatment. It acts as a binder, corrosion inhibitor, and cleaning booster, making it valuable in industrial cleaning products and cement formulations.",
    image: images["sodium_silicate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Silicate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Optical Brighteners are chemical compounds added to detergents, textiles, and paper to enhance whiteness and brightness. They work by absorbing UV light and re-emitting it as visible blue light, making materials appear cleaner and more vibrant.",
    image: images["optical_brighteners.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Optical Brighner",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Enzymes like Protease, Amylase, and Lipase are biological agents used in detergents to break down stains.",
    image: images["enzymes.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Enzymes",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Polycarboxylates are synthetic polymers used in detergents as water softeners and anti-redeposition agents.",
    image: images["polycarboxylates.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Polycarboxylates",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Cocamidopropyl Betaine is a mild surfactant derived from coconut oil, commonly used in shampoos, body washes, and liquid soaps. It helps create foam, cleanse the skin or hair gently, and reduce irritation when combined with stronger surfactants.",
    image: images["cocamidopropyl_betaine.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Cocamidopropyl Betaine",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Cocamide DEA/MEA are thickening and foaming agents derived from coconut oil, used in shampoos, body washes, and other personal care products. They enhance foam stability and viscosity, making the product feel richer and improving its cleansing performance.",
    image: images["cocamide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Cocamide DEA/MEA",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Citric Acid is a natural, weak organic acid used in food, cosmetics, and cleaning products. It acts as a pH adjuster, preservative, and chelating agent, helping to remove limescale, soften water, and extend product shelf life.",
    image: images["citric_acid.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Citric Acid",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Polyethylene Glycol (PEG) is a synthetic compound used in cosmetics, pharmaceuticals, and industrial products. It functions as a humectant, thickener, or solvent, helping to retain moisture, improve texture, and enhance the stability of formulations.",
    image: images["polyethylene_glycol.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Polyethylene Glycol",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Alkyl Polyglucosides (APGs) are mild, plant-derived surfactants commonly used in natural and eco-friendly cleaning and personal care products. They provide gentle cleansing and good foaming without irritating the skin, making them suitable for baby products and sensitive skin formulations.",
    image: images["alkylpolyglucosides.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Alkyl Polyglucosides",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Lauryl Ether Sulfate (SLES) is a widely used surfactant and foaming agent in shampoos, body washes, and household cleaners. It effectively removes oils and dirt while producing rich lather, offering a gentler alternative to Sodium Lauryl Sulfate (SLS).",
    image: images["SLES.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "SLES",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Dodecylbenzenesulfonate is a powerful anionic surfactant used in household and industrial detergents. It effectively breaks down grease and oily stains, making it a key ingredient in laundry powders, dishwashing liquids, and cleaning agents.",
    image: images["SDBS.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "SDBS",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Chlorate is a powerful oxidizing agent used in the production of chlorine dioxide for bleaching and disinfecting. It is also employed in industrial cleaning processes and as a herbicide, contributing to water treatment and surface sanitation.",
    image: images["sodium_chlorate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Chlorate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Acetone is a volatile organic solvent widely used in cleaning products, nail polish removers, and industrial degreasers. Its ability to dissolve oils, resins, and adhesives makes it effective for surface cleaning and preparation in household and industrial applications.",
    image: images["acetone.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Acetone",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Phenol is a potent disinfectant and antiseptic used in cleaning products and medical applications. It is effective against a wide range of pathogens and is commonly found in household disinfectants, mouthwashes, and industrial sanitizers.",
    image: images["phenol.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Phenol",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Hydrogen Peroxide is a versatile oxidizing agent used as a disinfectant, bleach, and cleaning agent. It is widely applied in household cleaners, laundry products, and surface sanitizers due to its ability to kill bacteria, viruses, and fungi.",
    image: images["hydrogen_peroxide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Hydrogen Peroxide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "cleaning"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "cleaning_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sokalon (Equivalent) refers to a high-performance polymer, typically a polycarboxylate-based compound, used in detergents as a dispersant and anti-redeposition agent. It enhances cleaning efficiency by preventing soil from resettling on fabrics and surfaces.",
    image: images["sokalon_equivalent.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sokalon (Equivalent)",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Phenol is a potent disinfectant and antiseptic used in cleaning products and medical applications. It is effective against a wide range of pathogens and is commonly found in household disinfectants, mouthwashes, and industrial sanitizers.",
    image: images["phenol.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Phenol",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Acetone is a volatile organic solvent used in disinfectant formulations and cleaning products. Its ability to dissolve organic materials makes it effective for surface preparation and sterilization in industrial and household settings.",
    image: images["acetone.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Acetone",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Hydrogen Peroxide is a versatile oxidizing agent used as a disinfectant, bleach, and cleaning agent. It is widely applied in household cleaners, laundry products, and surface sanitizers due to its ability to kill bacteria, viruses, and fungi.",
    image: images["hydrogen_peroxide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Hydrogen Peroxide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Citric Acid is a natural, weak organic acid used in disinfectant and cleaning products. It acts as a chelating agent and pH adjuster, helping to remove limescale and enhance the efficacy of sanitizing formulations in household and industrial applications.",
    image: images["citric_acid.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Citric Acid",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Hypochlorite is a powerful disinfectant and bleaching agent commonly used in household bleach, water treatment, and surface sanitizers. It effectively eliminates bacteria, viruses, and fungi, making it essential for disinfection in various settings.",
    image: images["sodium_hypochlorite.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Hypochlorite",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Quaternary Ammonium Compounds (Quats) are cationic surfactants widely used as disinfectants in household and industrial cleaners. They are effective against bacteria, viruses, and fungi, commonly found in surface sprays and wipes.",
    image: images["quaternary_ammonium_compounds.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Quaternary Amonium",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Chlorine is a strong disinfectant used in water treatment, pool sanitation, and surface cleaning. It is highly effective against a broad spectrum of microorganisms, making it a key component in disinfecting solutions and bleaching agents.",
    image: images["chlorine.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Chlorine",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Isopropyl Alcohol (IPA) is a widely used disinfectant and solvent in cleaning products. Its rapid evaporation and ability to kill bacteria, viruses, and fungi make it ideal for surface disinfection in medical and household applications.",
    image: images["isopropyl_alcohol.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Isopropyl Alcohol (IPA)",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Chlorate is a powerful oxidizing agent used in the production of chlorine dioxide for bleaching and disinfecting. It is also employed in industrial cleaning processes and as a herbicide, contributing to water treatment and surface sanitation.",
    image: images["sodium_chlorate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Chlorate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Acetic Acid is a weak organic acid used in disinfectant and cleaning products. It is effective for descaling, pH adjustment, and antimicrobial applications, commonly found in vinegar-based cleaners for household and industrial use.",
    image: images["acetic_acid.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Acetic Acid",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Nitrobenzene is an organic compound used in the synthesis of disinfectants and cleaning agents. It serves as a precursor in the production of aniline and other chemicals used in sanitizing formulations.",
    image: images["nitrobenzene.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Nitrobenzene",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Aniline is an organic compound used in the production of disinfectants and antimicrobial agents. It serves as a key intermediate in synthesizing chemicals for sanitizing and cleaning applications.",
    image: images["aniline.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Aniline",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Carbonate, also known as soda ash, is used in disinfectant and cleaning formulations for its water-softening and pH-regulating properties. It enhances cleaning efficiency and supports antimicrobial action in household and industrial products.",
    image: images["sodium_carbonate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Carbonate (Soda Ash)",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Calcium Hypochlorite is a strong oxidizing agent used as a disinfectant in water treatment, pool sanitation, and surface cleaning. It releases chlorine to kill bacteria and pathogens, making it effective for large-scale disinfection.",
    image: images["calcium_hypochlorite.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Calcium Hypochlorite",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Sodium Bicarbonate, commonly known as baking soda, is used in disinfectant and cleaning products for its mild abrasive and pH-neutralizing properties. It supports odor elimination and surface cleaning in household applications.",
    image: images["sodium_bicarbonate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Sodium Bicarbonate (Baking Soda)",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Potassium Permanganate is a strong oxidizing agent used as a disinfectant in water treatment and medical applications. It is effective against bacteria and fungi, often used for wound cleansing and surface sanitation.",
    image: images["potassium_permanganate.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Potassium Permanganate",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Zinc Oxide is used in disinfectant and antiseptic formulations, particularly in medical and cosmetic products. It provides antimicrobial properties and is commonly found in ointments and surface treatments for sanitization.",
    image: images["zinc_oxide.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Zinc Oxide",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Benzalkonium Chloride is a quaternary ammonium compound used as a disinfectant and preservative in cleaning products and medical applications. It is effective against bacteria, fungi, and viruses, commonly used in surface disinfectants and hand sanitizers.",
    image: images["benzalkonium_chloride.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Benzalkonium Chloride",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Chlorhexidine is a broad-spectrum antiseptic used in disinfectants for medical and dental applications. It is highly effective against bacteria and fungi, commonly used in mouthwashes, wound care, and surface disinfection.",
    image: images["chlorhexidine.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Chlorhexidine",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
  {
    price: 15,
    discount: 0,
    tag: ["chemicals", "disinfectant"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "disinfectant_chemicals",
    createdAt: "2021-12-22T16:41:23.216Z",
    description: "Iodophors (Iodine-based Disinfectants) are complexes of iodine used for disinfection in medical and industrial settings. They are effective against a wide range of microorganisms and are commonly used in sanitizing solutions and skin antiseptics.",
    image: images["Iodophors.jpeg"],
    originalPrice: 15,
    parent: "Chemicals",
    quantity: 42,
    slug: "chemicals",
    title: "Iodophors",
    type: "chemicals",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0
  },
];

export const discountProducts = [
  {
    price: 10,
    discount: 17,
    tag: ["bell-pepper", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4e2",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.214Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-27.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 99,
    slug: "organic-bell-pepper",
    title: "Organic Bell Pepper",
    type: "Grocery",
    unit: "22ct",
    updatedAt: "2022-07-08T14:26:08.089Z",
    sku: "",
    __v: 0,
  },
  {
    price: 10,
    discount: 16.666666666666664,
    tag: ["pumpkin", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4df",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.214Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-30.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 118,
    slug: "mini-pumpkin",
    title: "Mini Pumpkin",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-07-08T14:26:08.090Z",
    sku: "F0054",
    __v: 0,
  },
  {
    price: 14,
    discount: 7,
    tag: ["cauliflower", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4dc",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.214Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-33.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 84,
    slug: "iglotex-cauliflower",
    title: "Iglotex Cauliflower",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-07-14T12:27:24.539Z",
    sku: "",
    __v: 0,
  },
  {
    price: 11,
    discount: 8.333333333333332,
    tag: ["beans", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4db",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.214Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-34.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 100,
    slug: "french-green-beans",
    title: "French Green Beans",
    type: "Grocery",
    unit: "16ct",
    updatedAt: "2022-01-20T05:19:07.596Z",
    sku: "F0054",
    __v: 0,
  },
  {
    price: 13,
    discount: 7,
    tag: ["escarole", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4d9",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.214Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-36.png"],
    originalPrice: 14,
    parent: "Fruits & Vegetable",
    quantity: 109,
    slug: "escarole",
    title: "Escarole",
    type: "Grocery",
    unit: "1ct",
    updatedAt: "2022-05-09T16:11:52.335Z",
    sku: "",
    __v: 0,
  },
  {
    price: 8,
    discount: 20,
    tag: ["mango", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4d5",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-40.png"],
    originalPrice: 10,
    parent: "Fruits & Vegetable",
    quantity: 170,
    slug: "haitian-mango",
    title: "Haitian Mangoe",
    type: "Grocery",
    unit: "8ct",
    updatedAt: "2021-12-22T16:41:23.213Z",
    sku: "",
    __v: 0,
  },
  {
    price: 13,
    discount: 13,
    tag: ["cranberries", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4d3",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-42.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 100,
    slug: "cranberries",
    title: "Cranberries",
    type: "Grocery",
    unit: "9.5oz",
    updatedAt: "2021-12-22T16:41:23.213Z",
    sku: "",
    __v: 0,
  },
  {
    price: 11,
    discount: 8,
    tag: ["clementine", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4d2",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-43.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 168,
    slug: "mandarin-clementine",
    title: "Mandarin Clementine",
    type: "Grocery",
    unit: "22lb",
    updatedAt: "2022-05-09T23:38:03.700Z",
    sku: "",
    __v: 0,
  },
  {
    price: 9,
    discount: 10,
    tag: ["organic food", "orange"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4ca",
    children: "Organic Food",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "Organic food is food produced by methods complying with the standards of organic farming. Standards vary worldwide, but organic farming features practices that cycle resources, promote ecological balance, and conserve biodiversity.",
    image: images["product-51.png"],
    originalPrice: 10,
    parent: "Organic Food",
    quantity: 64,
    slug: "orange-imported",
    title: "Orange Imported",
    type: "Grocery",
    unit: "1kg",
    updatedAt: "2022-06-29T18:21:54.036Z",
    sku: "",
    __v: 0,
  },
  {
    price: 10,
    discount: 9.090909090909092,
    tag: ["organic food", "china apple"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4c9",
    children: "Organic Food",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "Organic food is food produced by methods complying with the standards of organic farming. Standards vary worldwide, but organic farming features practices that cycle resources, promote ecological balance, and conserve biodiversity.",
    image: images["product-52.png"],
    originalPrice: 11,
    parent: "Organic Food",
    quantity: 59,
    slug: "china-fuji-apple",
    title: "China Fuji Apple",
    type: "Grocery",
    unit: "1kg",
    updatedAt: "2022-07-15T19:26:14.502Z",
    sku: "F0054",
    __v: 0,
  },
  {
    price: 10,
    discount: 16.666666666666664,
    tag: ["organic food", "orange-jelly"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4c7",
    children: "Organic Food",
    createdAt: "2021-12-22T16:41:23.213Z",
    description:
      "Organic food is food produced by methods complying with the standards of organic farming. Standards vary worldwide, but organic farming features practices that cycle resources, promote ecological balance, and conserve biodiversity.",
    image: images["product-54.png"],
    originalPrice: 12,
    parent: "Organic Food",
    quantity: 65,
    slug: "sugar-free-orange-jelly",
    title: "Sugar Free Orange Jelly",
    type: "Grocery",
    unit: "375gm",
    updatedAt: "2022-06-11T11:44:56.199Z",
    sku: "F0054",
    __v: 0,
  },
  {
    price: 10,
    discount: 9,
    tag: ["organic food", "pineapple"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4c5",
    children: "Organic Food",
    createdAt: "2021-12-22T16:41:23.212Z",
    description:
      "Organic food is food produced by methods complying with the standards of organic farming. Standards vary worldwide, but organic farming features practices that cycle resources, promote ecological balance, and conserve biodiversity.",
    image: images["product-56.png"],
    originalPrice: 11,
    parent: "Organic Food",
    quantity: 69,
    slug: "pineapple",
    title: "Pineapple",
    type: "Grocery",
    unit: "1pcs",
    updatedAt: "2022-06-09T03:33:49.059Z",
    sku: "",
    __v: 0,
  },
];

export const popularProducts = [
  {
    price: 12,
    discount: 0,
    tag: ["rainbow-chard", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fd",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-1.png"],

    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: -0,
    slug: "rainbow-chard",
    title: "Rainbow Chard",
    type: "Grocery",
    unit: "1lb",
    updatedAt: "2022-05-13T03:52:58.986Z",
    sku: "",
    __v: 0,
  },
  {
    price: 13,
    discount: 0,
    tag: ["clementine", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fc",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-2.png"],
    originalPrice: 13,
    parent: "Fruits & Vegetable",
    quantity: 0,
    slug: "clementine",
    title: "Clementine",
    type: "Grocery",
    unit: "5ct",
    updatedAt: "2022-01-19T20:18:00.564Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["rainbow-peppers", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4fa",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-3.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 0,
    slug: "rainbow-peppers",
    title: "Rainbow Peppers",
    type: "Grocery",
    unit: "4ct",
    updatedAt: "2022-06-19T14:37:33.108Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["blueberries", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f9",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-4.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 29,
    slug: "blueberry",
    title: "Blueberry",
    type: "Grocery",
    unit: "25qt",
    updatedAt: "2022-07-16T15:41:09.773Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["calabaza-squash", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f8",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-5.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 42,
    slug: "calabaza-squash",
    title: "Calabaza Squash",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-07-05T14:57:19.980Z",
    sku: "",
    __v: 0,
  },
  {
    price: 14,
    discount: 0,
    tag: ["lettuce", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f7",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-6.png"],
    originalPrice: 14,
    parent: "Fruits & Vegetable",
    quantity: 83,
    slug: "lettuce",
    title: "Lettuce",
    type: "Grocery",
    unit: "1lb",
    updatedAt: "2022-07-11T05:18:44.963Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["radicchio", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f6",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-7.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 0,
    slug: "radicchio",
    title: "Radicchio",
    type: "Grocery",
    unit: "12ct",
    updatedAt: "2022-01-19T04:32:10.877Z",
    sku: "F0056",
    __v: 0,
  },
  {
    price: 12,
    discount: 0,
    tag: ["parsley", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f5",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.216Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-8.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 54,
    slug: "parsley",
    title: "Parsley",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-07-05T18:39:53.960Z",
    sku: "",
    __v: 0,
  },
  {
    price: 13,
    discount: 0,
    tag: ["strawberries", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f4",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-9.png"],
    originalPrice: 13,
    parent: "Fruits & Vegetable",
    quantity: 13,
    slug: "strawberrie",
    title: "Strawberrie",
    type: "Grocery",
    unit: "25oz",
    updatedAt: "2022-07-15T11:19:42.480Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["cauliflower", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f3",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-10.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 76,
    slug: "cauliflower",
    title: "Cauliflower",
    type: "Grocery",
    unit: "35lb",
    updatedAt: "2022-06-29T00:55:21.217Z",
    sku: "",
    __v: 0,
  },
  {
    price: 11,
    discount: 0,
    tag: ["cauliflower", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f2",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-11.png"],
    originalPrice: 11,
    parent: "Fruits & Vegetable",
    quantity: 110,
    slug: "organic-purple-cauliflower",
    title: "Organic Purple Cauliflower",
    type: "Grocery",
    unit: "1lb",
    updatedAt: "2022-06-17T15:38:38.622Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["squash", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f1",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-12.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 0,
    slug: "ahold-acorn-squash",
    title: "Ahold Acorn Squash",
    type: "Grocery",
    unit: "1ct",
    updatedAt: "2022-05-09T07:02:59.121Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["cabbage", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4f0",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-13.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 89,
    slug: "bok-choy-cabbage",
    title: "Bok Choy Cabbage",
    type: "Grocery",
    unit: "1lb",
    updatedAt: "2022-07-12T18:06:19.481Z",
    sku: "",
    __v: 0,
  },
  {
    price: 14,
    discount: 0,
    tag: ["strawberries", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4ef",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-14.png"],
    originalPrice: 14,
    parent: "Fruits & Vegetable",
    quantity: 80,
    slug: "strawberries-package",
    title: "Strawberries Package",
    type: "Grocery",
    unit: "25oz",
    updatedAt: "2022-06-17T12:14:43.031Z",
    sku: "",
    __v: 0,
  },
  {
    price: 15,
    discount: 0,
    tag: ["aloe-vera-leaf", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4ee",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-15.png"],
    originalPrice: 15,
    parent: "Fruits & Vegetable",
    quantity: 94,
    slug: "aloe-vera-leaf",
    title: "Aloe Vera Leaf",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-06-17T12:14:43.031Z",
    sku: "",
    __v: 0,
  },
  {
    price: 12,
    discount: 0,
    tag: ["pineapple", "fresh fruits"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4ed",
    children: "Fresh Fruits",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "In a botanical sense, a fruit is the fleshy or dry ripened ovary of a flowering plant, enclosing the seed or seeds. Apricots, bananas, and grapes, as well as bean pods, corn grains, tomatoes, cucumbers, and (in their shells) acorns and almonds, are all technically fruits.",
    image: images["product-16.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 49,
    slug: "pineapple-imported",
    title: "Pineapple Imported",
    type: "Grocery",
    unit: "5lb",
    updatedAt: "2022-06-26T18:26:14.825Z",
    sku: "",
    __v: 0,
  },
  {
    price: 12,
    discount: 0,
    tag: ["broccoli", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4ec",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-17.png"],
    originalPrice: 12,
    parent: "Fruits & Vegetable",
    quantity: 145,
    slug: "organic-broccoli",
    title: "Organic Broccoli",
    type: "Grocery",
    unit: "10oz",
    updatedAt: "2022-06-06T17:25:20.435Z",
    sku: "",
    __v: 0,
  },
  {
    price: 14,
    discount: 0,
    tag: ["avocado", "fresh vegetable"],
    flashSale: false,
    status: "Show",
    id: "61c355337f19aa31349af4eb",
    children: "Fresh Vegetable",
    createdAt: "2021-12-22T16:41:23.215Z",
    description:
      "Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with only about 3.5 percent protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet potatoes, and turnips. Stem vegetables include asparagus and kohlrabi.",
    image: images["product-18.png"],
    originalPrice: 14,
    parent: "Fruits & Vegetable",
    quantity: 146,
    slug: "organic-pinkerton-avocado",
    title: "Organic Pinkerton Avocado",
    type: "Grocery",
    unit: "each",
    updatedAt: "2022-07-08T14:35:27.983Z",
    sku: "",
    __v: 0,
  }

];

export function getProductById(title) {
  return Products.find((product) => product.slug === title);
}

export function getProductByChildrenCategory(category) {
  return Products.filter(
    (product) => product.children.toLowerCase() === category.toLowerCase()
  );
}

export function getProductByParentCategory(category) {
  return Products.filter(
    (product) => product.parent.toLowerCase() === category.toLowerCase()
  );
}

export function getProductByName(value) {
  return Products.filter((product) =>
    product.title.toLowerCase().includes(value.toLowerCase())
  );
}
